// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3m1lE","controls":"styles_controls__2pB8s","charLimit":"styles_charLimit__1P3e6","input":"styles_input__Ltsyc","send":"styles_send__3ob3N"};